import {actionTypes} from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: []
}

export default (state = initialState, action) => {
	switch (action.type) {
        case actionTypes.STORE_YOUTUBE_AUTH_REQUEST:
            return {
                ...state,
                loading: true,
            }
		case actionTypes.STORE_YOUTUBE_AUTH_SUCCESS:
			return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.STORE_YOUTUBE_AUTH_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.STORE_YOUTUBE_AUTH_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.STORE_YOUTUBE_AUTH_RESET_ALL:
            return initialState
		default:
			return state;
	}
};
